export default __webpack_public_path__ + "education_m2f8a7c.jpg";